import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-ce068f0a.js';
import { I as Icon } from './chunk-4139443a.js';
export { I as BIcon } from './chunk-4139443a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Icon);
  }
};
use(Plugin);

export default Plugin;
